import React, { useContext, useState, useEffect } from "react"
import Context from "../utils/Context"
import { sendTaskToRobot, cancelActions } from "../utils/ROS/ROSFunctions"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faStopCircle, faCog, faFileExport, faFileImport } from '@fortawesome/free-solid-svg-icons'
import ShowMessage from "./ShowMessage"
import api from "../api/api"

export default function Tasks() {

  const context = useContext(Context)
  const [showWarning, setShowWarning] = useState(false)
  const [showCountdown, setShowCountdown] = useState(false)
  const [countdown, setCountdown] = useState(10)
  const [timer, setTimer] = useState(null)
  const [currentMap, setCurrentMap] = useState()

  useEffect(() => {
    let map = context.maps.find(m => m.name === context.selected.map?.name && m.robotId === context.robotInfo._id)
    setCurrentMap(map)
    let taskCounter = 0
    if (map) {
      context.availableTasks.forEach((task) => {
        if (task.robot === context.selectedRobot.name && task.mapId === map._id) taskCounter++
      })
      console.log(context.availableTasks, taskCounter)
      if (taskCounter === 0 && context.settings.fmsConnection) context.actions.setModalState({ ...context.modalState, import: true })
    }
  }, [])

  const importTasks = () => {
    if (currentMap) {
      api.fetchTasks({ mapId: currentMap._id })
        .then(response => {
          if (response?.data) {
            console.log(response)

            const importedTasksMap = new Map(response.data.map(task => [task.name, task]))

            const updatedTasks = [
              ...context.availableTasks.filter(task => !importedTasksMap.has(task.name)),
              ...response.data
            ]

            context.actions.setAvailableTasks(updatedTasks)
          }
        })

      closeModal('import')
    } else context.actions.setMessage({ message: "You need to select a map to import tasks.", type: "error" })
  }

  const exportTasks = () => {
    if (currentMap) {
      api.deleteTasks(currentMap._id)
        .then(() => {
          console.log("Tasks deleted!")
          if (context.availableTasks?.length > 0) {
            context.availableTasks.forEach((task) => {
              api.saveTask(task)
                .then(response => {
                  console.log("Task inserted: ", response)
                })
            })
          }
        })

      closeModal('export')
    } else context.actions.setMessage({ message: "You need to select a map to export tasks.", type: "error" })
  }

  // start task
  const startTask = (task) => {
    if (task) {
      const counterRemover = task.actions.map(action => ({
        ...action,
        id: action.name
      }))
      sendTaskToRobot({ actions: counterRemover, id: task.name, name: task.name }, context.selectedRobot.ROS)
      console.log('publishing task: ', { actions: counterRemover, id: task.name, name: task.name })
    }
  }

  // execute a task
  const execTask = (taskName) => {
    const task = context.availableTasks.find(m => m.name === taskName)
    const hasUV = task?.actions?.find(action => action.name === "desinfect-uv" || action.name === "desinfect-all")

    if (task) {
      //context.actions.setCurrentTask({ ...task, hasUV: hasUV ? true : false })
    }

    if (hasUV) {
      setShowWarning(true)
    } else {
      startTask(task)
    }
  }

  const stopMission = () => {
    if (context.selectedRobot.ROS === 'ROS2') {
      cancelActions({ stopall: true }, context.selectedRobot.ROS)
    } else {
      cancelActions({ stopAll: true }, context.selectedRobot.ROS)
    }
    //context.actions.setCurrentTask(null)
    context.actions.setMessage({ message: "Tarefa cancelada!", type: "success" })
  }

  // start countdown
  const startCountdown = () => {
    setShowCountdown(true)

    setTimer(
      setInterval(() => {
        setCountdown(c => c - 1)
      }, 1000)
    )
  }

  const closeModal = (type) => {
    document.getElementById(type + '-modal').classList.remove('is-active')
  }

  const openModal = (type) => {
    document.getElementById(type + '-modal').classList.add('is-active')
  }

  // end of countdown
  useEffect(() => {
    if (countdown === 0) {
      clearInterval(timer)
      setTimer(null)
      setShowCountdown(false)
      setCountdown(10)
      startTask(context.currentTask)
      setShowWarning(false)
    }
  }, [countdown, context.currentTask, timer])

  return (
    <div>
      <div className="modal" id='import-modal'>
        <div className="modal-background"></div>
        <div className="modal-card" onClick={(e) => e.stopPropagation()}>

          <header className="modal-card-head">
            <p className="modal-card-title">Import Tasks</p>
            <button
              className="delete"
              aria-label="close"
              onClick={() => closeModal('import')}
            ></button>
          </header>

          <section className="modal-card-body">

            <div className="field mb-5">
              Importing tasks will overwrite your current tasks should they share the same name.
              <br />
              Are you sure?
            </div>

            <ShowMessage />

          </section>

          <footer className="modal-card-foot">
            <button className="button is-success" onClick={importTasks}>
              <span className="icon is-small">
                <FontAwesomeIcon icon={faFileImport} className="fas" />
              </span>
              <span>Yes</span>
            </button>
            <button className="button" onClick={() => closeModal('import')}>
              <span>No</span>
            </button>
          </footer>
        </div>
      </div>

      <div className="modal" id='export-modal'>
        <div className="modal-background"></div>
        <div className="modal-card" onClick={(e) => e.stopPropagation()}>

          <header className="modal-card-head">
            <p className="modal-card-title">Export Tasks</p>
            <button
              className="delete"
              aria-label="close"
              onClick={() => closeModal('export')}
            ></button>
          </header>

          <section className="modal-card-body">

            <div className="field mb-5">
              Exporting tasks will delete all currently saved tasks on the server.
              <br />
              Are you sure?
            </div>

            <ShowMessage />

          </section>

          <footer className="modal-card-foot">
            <button className="button is-success" onClick={exportTasks}>
              <span className="icon is-small">
                <FontAwesomeIcon icon={faFileExport} className="fas" />
              </span>
              <span>Yes</span>
            </button>
            <button className="button" onClick={() => closeModal('export')}>
              <span>No</span>
            </button>
          </footer>
        </div>
      </div>

      <button
        onClick={() => context.actions.setModalState({ ...context.modalState, tasks: true })}
        className="button is-success mb-5 mr-3"
        style={{ marginRight: "1rem" }}
      >
        <FontAwesomeIcon icon={faPlus} className="is-small mr-1" />
        Manage Tasks
      </button>

      <button
        onClick={stopMission}
        className="button is-danger mb-5 mr-3"
      >
        <FontAwesomeIcon icon={faStopCircle} className="is-small mr-1" />
        Stop Mission
      </button>

      {context.availableTasks.length > 0 && currentMap &&
        context.availableTasks.map((task, i) => (
          task.robot === context.selectedRobot.name && task.mapId === currentMap._id &&
          <button key={i} className="button is-outlined is-link mr-2 mb-2" onClick={() => execTask(task.name)}>
            {task.name + " "}
          </button>
        ))}

      {context.availableTasks.length > 0 && !currentMap &&
        context.availableTasks.map((task, i) => (
          task.robot === context.selectedRobot.name &&
          <button key={i} className="button is-outlined is-link mr-2 mb-2" onClick={() => execTask(task.name)}>
            {task.name + " "}
          </button>
        ))}

      {context.settings.fmsConnection &&
        <>
          <button className="button is-warning is-light ml-2" onClick={() => openModal('export')} style={{ float: 'right' }}>
            <span className="icon is-small">
              <FontAwesomeIcon icon={faFileExport} className="is-small mr-1" />
            </span>
            <span className="is-size-7">Export Tasks</span>
          </button>

          <button className="button is-outlined ml-2" onClick={() => openModal('import')} style={{ float: 'right' }}>
            <span className="icon is-small">
              <FontAwesomeIcon icon={faFileImport} className="is-small mr-1" />
            </span>
            <span className="is-size-7">Import Tasks</span>
          </button>
        </>
      }

      <ShowMessage />

      <div id="modal" className={showWarning ? "modal is-active" : "modal"}>
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">UV Light usage confirmation</p>
            <button className="delete" aria-label="close"></button>
          </header>

          <section className="modal-card-body">
            <div className="controls">
              {
                showCountdown ?
                  <div className="control">
                    <p>{countdown} seconds to start...</p>
                  </div>
                  :
                  <div className="control">
                    <p>You will turn on the UV Lights, are you sure?</p>
                    <p>You will have 10 seconds to leave the room and close the door.</p>
                  </div>
              }
            </div>
          </section>

          <footer className="modal-card-foot">
            {!showCountdown &&
              <>
                <button className="button is-success" onClick={startCountdown}>
                  <span className="icon is-small">
                    <FontAwesomeIcon icon={faCog} className="fas" />
                  </span>
                  <span>Confirm</span>
                </button>

                <button className="button" onClick={() => setShowWarning(false)}>
                  Cancel
                </button>
              </>
            }
          </footer>

        </div>
      </div>
    </div>
  )
}